// @owners { team: patients }
import { type Brand, getBrand } from '@alto/design-system';

export type CompanyName = 'Alto' | 'Fuze Health' | 'FuzeRx';
export type CompanyFullName = 'Alto Pharmacy' | 'Fuze Health' | 'FuzeRx';

const COMPANY_NAME: Record<Brand, CompanyName> = {
  alto: 'Alto',
  fuzehealth: 'Fuze Health',
  fuzerx: 'FuzeRx',
};

const COMPANY_FULL_NAME: Record<Brand, CompanyFullName> = {
  alto: 'Alto Pharmacy',
  fuzehealth: 'Fuze Health',
  fuzerx: 'FuzeRx',
};

/**
 * Get the company display name based on the current brand.
 * @returns CompanyName ('Alto', 'Fuze Health', or 'FuzeRx')
 */
export const getCompanyName = (): CompanyName => COMPANY_NAME[getBrand()];

/**
 * Get the company's full display name based on the current brand.
 * @returns CompanyFullName ('Alto Pharmacy', 'Fuze Health', or 'FuzeRx')
 */
export const getCompanyFullName = (): CompanyFullName => COMPANY_FULL_NAME[getBrand()];
